import { render, staticRenderFns } from "./ReComment.vue?vue&type=template&id=6b6929df&scoped=true"
import script from "./ReComment.vue?vue&type=script&lang=js"
export * from "./ReComment.vue?vue&type=script&lang=js"
import style0 from "./ReComment.vue?vue&type=style&index=0&id=6b6929df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6929df",
  null
  
)

export default component.exports